import React from 'react'

import { CreateJointPlanModal } from '../../components/Modal/CreateJointPlanModal'
import routes from '@utils/routes'

export const NewJointScenario = ({
  clientName,
  clientId,
  allClients,
  tenant
}) => {
  const createJointScenarioPath = routes.jointScenarioPath({
    tenantSlug: tenant,
    clientId: clientId
  })


  return (
    <CreateJointPlanModal
      open
      createJointScenarioPath={createJointScenarioPath}
      name={clientName}
      clients={allClients}
    />
  )
}
